"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enums = exports.ChangeType = exports.ProgressStatus = exports.RagStatus = exports.UiPositions = exports.ElementTypes = exports.UiSizes = exports.LogLevel = exports.ErrorCode = void 0;
//Application Errors for test
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NullPointerException"] = 1] = "NullPointerException";
    ErrorCode[ErrorCode["NetworkDown"] = 2] = "NetworkDown";
    ErrorCode[ErrorCode["RequestFailed"] = 3] = "RequestFailed";
    ErrorCode[ErrorCode["AccessDenied"] = 4] = "AccessDenied";
    ErrorCode[ErrorCode["FormValidationFailed"] = 5] = "FormValidationFailed";
    ErrorCode[ErrorCode["FieldValidationFailed"] = 6] = "FieldValidationFailed";
    ErrorCode[ErrorCode["RequestTimeout"] = 7] = "RequestTimeout";
    ErrorCode[ErrorCode["ResourceUnreachable"] = 8] = "ResourceUnreachable";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
//Application Log Constants
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Diagnostics"] = 1] = "Diagnostics";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warning"] = 4] = "Warning";
    LogLevel[LogLevel["Error"] = 8] = "Error";
    LogLevel[LogLevel["All"] = 15] = "All";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
var UiSizes;
(function (UiSizes) {
    UiSizes["XXS"] = "xxs";
    UiSizes["XS"] = "xs";
    UiSizes["SM"] = "sm";
    UiSizes["MD"] = "md";
    UiSizes["LG"] = "lg";
})(UiSizes = exports.UiSizes || (exports.UiSizes = {}));
var ElementTypes;
(function (ElementTypes) {
    ElementTypes[ElementTypes["ORGANISATION"] = 1] = "ORGANISATION";
    ElementTypes[ElementTypes["PROGRAMME"] = 2] = "PROGRAMME";
    ElementTypes[ElementTypes["PROJECT"] = 3] = "PROJECT";
    ElementTypes[ElementTypes["IMPACT"] = 4] = "IMPACT";
    ElementTypes[ElementTypes["ACTION"] = 5] = "ACTION";
    ElementTypes[ElementTypes["STAKEHOLDER"] = 6] = "STAKEHOLDER";
    ElementTypes[ElementTypes["AUDIENCE"] = 7] = "AUDIENCE";
    ElementTypes[ElementTypes["IMPACTTYPE"] = 8] = "IMPACTTYPE";
    ElementTypes[ElementTypes["NOT_STARTED_ACTION"] = 9] = "NOT_STARTED_ACTION";
    ElementTypes[ElementTypes["IN_PROGRESS_ACTION"] = 10] = "IN_PROGRESS_ACTION";
    ElementTypes[ElementTypes["UNKNOWN_STAKEHOLDER"] = 11] = "UNKNOWN_STAKEHOLDER";
    ElementTypes[ElementTypes["CONCERNED_STAKEHOLDER"] = 12] = "CONCERNED_STAKEHOLDER";
    ElementTypes[ElementTypes["NEUTRAL_STAKEHOLDER"] = 13] = "NEUTRAL_STAKEHOLDER";
    ElementTypes[ElementTypes["ADVOCATE_STAKEHOLDER"] = 14] = "ADVOCATE_STAKEHOLDER";
    ElementTypes[ElementTypes["UNKNOWN_AUDIENCE"] = 15] = "UNKNOWN_AUDIENCE";
    ElementTypes[ElementTypes["CONCERNED_AUDIENCE"] = 16] = "CONCERNED_AUDIENCE";
    ElementTypes[ElementTypes["NEUTRAL_AUDIENCE"] = 17] = "NEUTRAL_AUDIENCE";
    ElementTypes[ElementTypes["ADVOCATE_AUDIENCE"] = 18] = "ADVOCATE_AUDIENCE";
    ElementTypes[ElementTypes["RED_RAG_ACTION"] = 19] = "RED_RAG_ACTION";
    ElementTypes[ElementTypes["AMBER_RAG_ACTION"] = 20] = "AMBER_RAG_ACTION";
    ElementTypes[ElementTypes["GREEN_RAG_ACTION"] = 21] = "GREEN_RAG_ACTION";
    ElementTypes[ElementTypes["COMPLETE_RAG_ACTION"] = 22] = "COMPLETE_RAG_ACTION";
    ElementTypes[ElementTypes["UNKNOWN_RAG_ACTION"] = 23] = "UNKNOWN_RAG_ACTION";
    ElementTypes[ElementTypes["HIGH_LEVEL_IMPACT"] = 24] = "HIGH_LEVEL_IMPACT";
    ElementTypes[ElementTypes["MEDIUM_LEVEL_IMPACT"] = 25] = "MEDIUM_LEVEL_IMPACT";
    ElementTypes[ElementTypes["LOW_LEVEL_IMPACT"] = 26] = "LOW_LEVEL_IMPACT";
    ElementTypes[ElementTypes["UNKNOWN_LEVEL_IMPACT"] = 27] = "UNKNOWN_LEVEL_IMPACT";
})(ElementTypes = exports.ElementTypes || (exports.ElementTypes = {}));
var UiPositions;
(function (UiPositions) {
    UiPositions["LEFT"] = "left";
    UiPositions["RIGHT"] = "right";
    UiPositions["TOP"] = "top";
    UiPositions["BOTTOM"] = "bottom";
    UiPositions["MIDDLE"] = "middle";
})(UiPositions = exports.UiPositions || (exports.UiPositions = {}));
var RagStatus;
(function (RagStatus) {
    RagStatus[RagStatus["RED"] = 1] = "RED";
    RagStatus[RagStatus["AMBER"] = 2] = "AMBER";
    RagStatus[RagStatus["GREEN"] = 3] = "GREEN";
})(RagStatus = exports.RagStatus || (exports.RagStatus = {}));
var ProgressStatus;
(function (ProgressStatus) {
    ProgressStatus[ProgressStatus["NOT_STARTED"] = 1] = "NOT_STARTED";
    ProgressStatus[ProgressStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    ProgressStatus[ProgressStatus["COMPLETED"] = 3] = "COMPLETED";
    ProgressStatus[ProgressStatus["OVERDUE"] = 4] = "OVERDUE";
    ProgressStatus[ProgressStatus["ONHOLD"] = 5] = "ONHOLD";
    ProgressStatus[ProgressStatus["CANCELLED"] = 6] = "CANCELLED";
    ProgressStatus[ProgressStatus["DRAFT"] = 7] = "DRAFT";
})(ProgressStatus = exports.ProgressStatus || (exports.ProgressStatus = {}));
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["NEUTRAL"] = 0] = "NEUTRAL";
    ChangeType[ChangeType["NEGATIVE"] = 1] = "NEGATIVE";
    ChangeType[ChangeType["POSITIVE"] = 2] = "POSITIVE";
})(ChangeType = exports.ChangeType || (exports.ChangeType = {}));
exports.Enums = {
    ErrorCode: ErrorCode,
    LogLevel: LogLevel,
    UiSizes: UiSizes,
    UiPositions: UiPositions,
    RagStatus: RagStatus,
    ChangeType: ChangeType
};
